import { render, staticRenderFns } from "./NoSupplier.vue?vue&type=template&id=21973f8c&"
import script from "./NoSupplier.vue?vue&type=script&lang=js&"
export * from "./NoSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports